import type CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import useSiteState from '@app/state/SiteState';
import { getPricingRights } from '@util/PricingRights';

export const usePricingRights = (companyHotel: CompanyHotel | undefined) => {
    const principal = useSiteState(state => state.principal);
    return getPricingRights(principal, companyHotel);
};
